import { Box, CardMedia, styled } from '@mui/material'
import grid from 'assets/img/grid.webp'
import { useImgWithFallback, ImgWithFallbackInit } from 'features/common/hooks/useImgWithFallback'

interface WorkflowThumbnailProps {
  title: string
  url?: string
}

const StyledCardMedia = styled(CardMedia)(({ theme }) => ({
  height: theme.spacing(20.5),
  backgroundColor: 'rgba(248, 249, 249, 1)'
}))

function WorkflowThumbnail({ url, title }: WorkflowThumbnailProps) {
  const DEFAULT_THUMBNAIL = grid

  const thumbnailUrl = useImgWithFallback(url, DEFAULT_THUMBNAIL, ImgWithFallbackInit.Fallback)
  const properties = {
    component: 'img'
  }

  return (
    <Box overflow="hidden">
      <StyledCardMedia image={thumbnailUrl} title={title} {...properties} />
    </Box>
  )
}

export default WorkflowThumbnail
